import { isStandardBrowserEnv } from '@dimjs/lang';
import { utils } from '../../utils/index.js';
import { fabric } from './api.js';
import { bootstrap } from './bootstrap.js';

// Auto boostrap bridge engine.
(function () {
  if (isStandardBrowserEnv()) {
    const { webview, log } = utils;
    if (webview.isFabricWebview() && webview.isAndroid()) {
      // Load bridge core in `android` webview.
      log.logData('Load bridge core in `android` webview...');
      // Bootstrap brige infrastructure
      bootstrap(fabric);
    }
  }
})();

export const fabricAndroid = fabric;
